import { ReactElement } from "react";

// Type alias for the Gatsby wrapRootElement function.
type ElementWrapper = ({ element }: { element: ReactElement }) => ReactElement;

// Helper reducer function for consolidating higher order functions into a single ElementWrapper.
const wrapperFunctionReducer = (
  wrapper: ElementWrapper,
  currentWrapper: ElementWrapper,
): ElementWrapper => {
  return ({ element }) => wrapper({ element: currentWrapper({ element }) });
};

// wrapWithProviders combines multiple Gatsby ElementWrapper functions into a single function.
export const wrapWithProviders = (
  wrappers: ElementWrapper[],
): ElementWrapper => {
  return ({ element }: { element: ReactElement }) => {
    const wrappedElements = wrappers?.length
      ? wrappers.reduce(wrapperFunctionReducer)({ element })
      : element;
    return <>{wrappedElements}</>;
  };
};
